<template>
<base-modal title="Edit Cover Image">
  <form>
    <div class="columns">
      <div class="column">
        <file-input required
          button-text="Choose a file"
          class="is-boxed"
          hint="1000px x 667px"
          @select="setFile"
          :error="errors.file">
          Image
        </file-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button
          v-bind="{ working }"
          @submit="save"
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>
</template>

<script>
import { saveFile } from '@/api/facility'

export default {

  props: {
    facilityId: Number
  },

  data: () => ({
    working: false,
    file: ''
  }),

  methods: {
    setFile(file) {
      this.file = file
    },

    save() {
      this.working = true
      saveFile({
        facilityId: this.facilityId,
        file: this.file
      }, () => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }
}
</script>
